import { createElement, memo, useMemo } from '@max/max';
import View from '@hfe/max-view';
import Text from '@hfe/max-text';
import './index.scss';
import { FLIGHT_ARROW_ONEWAY_IMAGE_URL_SCROLL } from '../../../lib/utils/imageUtils';
const isWeb = true;
const isMRN = false;
import Price from '@max/leez-price';
import { getSystemType } from '@nibfe/mkt-env-api';
import Image from '@hfe/max-image';
const Recommend5 = (props) => {
    var _a, _b;
    const { city, index, jump, btColor } = props;
    const week = {
        Monday: '周一',
        Tuesday: '周二',
        Wednesday: '周三',
        Thursday: '周四',
        Friday: '周五',
        Saturday: '周六',
        Sunday: '周日'
    };
    const dateFormat = useMemo(() => {
        const date = new Date(props.city.date);
        const month = date.getMonth() + 1; // 月份从0开始，所以要加1
        const day = date.getDate();
        return `${month}月${day}日`;
    }, [props.city.date]);
    const isiOS = () => {
        const systemType = getSystemType();
        return (systemType === null || systemType === void 0 ? void 0 : systemType.toLowerCase()) === 'ios';
    };
    return <View className="recommend5-price-container" onClick={() => jump(city, index)}>
      <View x-if={((_a = city === null || city === void 0 ? void 0 : city.departCityName) === null || _a === void 0 ? void 0 : _a.length) + ((_b = city === null || city === void 0 ? void 0 : city.arriveCityName) === null || _b === void 0 ? void 0 : _b.length) > 5} className="recommend5-top-content" style={{
        marginTop: '8rpx'
    }}>
        <View className="recommend5-city">
          <Text className="recommend5-city-name" style={{
        fontSize: '22rpx'
    }}>
            {city.departCityName}
          </Text>
          <Image source={{
        uri: FLIGHT_ARROW_ONEWAY_IMAGE_URL_SCROLL
    }} style={{
        width: '30rpx',
        height: '30rpx',
        marginLeft: '6rpx',
        marginRight: '6rpx'
    }} className="recommend5-arrow"/>
          <Text className="recommend5-city-name" style={{
        fontSize: '22rpx'
    }}>
            {city.arriveCityName}
          </Text>
        </View>
        <Price type="l4" style={{
        fontSize: '28rpx',
        // height: isiOS() ? '28rpx' : '32rpx',
        flexShrink: 0,
        marginTop: isMRN && isiOS() ? '0rpx' : '-2rpx'
    }} content={city.price} className="price-field-sale-price-text" symbolStyle={{
        fontSize: '24rpx',
        fontWeight: '500',
        color: '#FF4B10',
        fontFamily: 'PingFang SC'
    }} priceStyle={{
        fontWeight: '700',
        color: '#FF4B10',
        fontSize: '28rpx'
    }}/>
      </View>
      <View x-else className="recommend5-top-content" style={{
        marginTop: '-2rpx'
    }}>
        <View className="recommend5-city">
          <Text className="recommend5-city-name">{city.departCityName}</Text>
          <Image source={{
        uri: FLIGHT_ARROW_ONEWAY_IMAGE_URL_SCROLL
    }} style={{
        width: '30rpx',
        height: '30rpx',
        marginLeft: '12rpx',
        marginRight: '12rpx'
    }} className="recommend5-arrow"/>
          <Text className="recommend5-city-name">{city.arriveCityName}</Text>
        </View>
        <Price type="l8" style={{
        fontSize: '36rpx',
        // height: isiOS() ? '48rpx' : '50rpx',
        flexShrink: 0,
        marginTop: isMRN && isiOS() ? '-2rpx' : '-4rpx'
    }} content={city.price} className="price-field-sale-price-text" symbolStyle={{
        fontSize: '24rpx',
        fontWeight: '500',
        color: '#FF4B10',
        fontFamily: 'PingFang SC'
    }} priceStyle={{
        fontWeight: '700',
        color: '#FF4B10',
        fontSize: '36rpx'
    }}/>
      </View>
      <View className="recommend5-bottom-content">
        <Text className="recommend5-font-grey" style={{
        marginTop: isMRN ? '-2rpx' : '0rpx'
    }}>
          {dateFormat + ' ' + week[city.week]}
        </Text>
        <View x-if={city.discout > 0 && city.discout < 100} className="recommend5-discout-container" style={{
        marginTop: isMRN && !isiOS() ? '-2rpx' : '0rpx'
    }}>
          <Text className={'recommend5-discout-text'}>{`${city.discout / 10}折`}</Text>
        </View>
      </View>
    </View>;
};
export default memo(Recommend5);
